import { render, staticRenderFns } from "./item_count.vue.js?vue&type=template&id=50c4b0c4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./item_count.vue?vue&type=template&id=50c4b0c4&vue3"
import script from "./item_count.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./item_count.vue?vue&type=script&lang=js&vue3"
export * from "./item_count.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./item_count.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports